import axios from '../../utils/axios2';

export default {

    namespaced: true,

    state: {
        tireBrand: null,
        tireBrands: null
    },

    mutations: {
        setTireBrand(state, payload) {
            state.tireBrand = payload;
        },
        setTireBrands(state, payload) {
            state.tireBrands = payload;
        }
    },

    actions: {
        storeTireBrand({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: "tire-brands",
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        updateTireBrand({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `tire-brands/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        removeTireBrand({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `tire-brands/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        fetchTireBrand({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `tire-brands/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit('setTireBrand', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        },
        fetchTireBrands({commit, rootState}) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `tire-brands`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit('setTireBrands', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        },
    }

}